module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent txtCenter"
  }, [_c('h2', {
    staticClass: "ff-light"
  }, [_vm._v(_vm._s(_vm.$t("favorite.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("favorite.name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.favoriteName),
      expression: "favoriteName"
    }],
    attrs: {
      "id": "favoriteName",
      "placeholder": "Favorite name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.favoriteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.favoriteName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn block pointer center",
    on: {
      "click": _vm.saveFavorite
    }
  }, [_vm._v(_vm._s(_vm.$t("favorite.save")))])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c9fd8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/ModalFavorite.vue
// module id = 3146
// module chunks = 0